import React from "react";
import { Box, Chip } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import { useTheme } from "@mui/material/styles";
import AvatarName from "../../../../components/molecules/AvatarName";
import MightyDataGrid from "../../../../components/organisms/MightyDataGrid";
import useEvents from "../../../../hooks/useEvents";

const CoachTable = ({ coaches, onCoachClicked, onAddCoachClicked }) => {
  const theme = useTheme();
  const events = useEvents();

  const columns = React.useMemo(() => {
    return [
      {
        field: "name",
        headerName: "Coach",
        headerAlign: "left",
        align: "left",
        flex: 2,
        hideable: false,
        sortable: true,
        filterable: false,
        renderCell: (params) => {
          return (
            <AvatarName
              showName={true}
              firstName={params.row.firstName}
              lastName={params.row.lastName}
              url={params.row.avatarUrl}
              size={32}
            />
          );
        },
      },
      {
        field: "status",
        headerName: "Status",
        headerAlign: "center",
        align: "center",
        width: 120,
        renderCell: (params) => {
          const isActive = params.value === "active";
          return (
            <Chip
              label={isActive ? "Active" : "Disabled"}
              color={isActive ? "success" : "default"}
              size="small"
              variant="outlined"
            />
          );
        },
      },
      {
        field: "role",
        headerName: "Role",
        headerAlign: "center",
        align: "center",
        width: 120,
        renderCell: (params) => {
          const isAdmin = params.value === "admin";
          return (
            <Chip
              label={isAdmin ? "Admin" : "Coach"}
              color={isAdmin ? "primary" : "default"}
              size="small"
              variant={isAdmin ? "filled" : "outlined"}
            />
          );
        },
      },
    ];
  }, [theme]);

  const rows = React.useMemo(() => {
    return coaches.map((coach) => {
      return {
        id: coach.uid,
        ...coach,
      };
    });
  }, [coaches]);

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
      }}
    >
      <Box
        style={{ marginRight: 24, marginBottom: 12, marginTop: 12 }}
        display="flex"
        justifyContent="flex-end"
      >
        <StandardButton
          variant="primary"
          onClick={() => {
            if (onAddCoachClicked) {
              onAddCoachClicked();
              events.logButtonClick({
                buttonName: "Add New Coach",
                pageName: "Coaches",
              });
            }
          }}
        >
          Add New Coach
        </StandardButton>
      </Box>
      {/* CHANGE HEIGHT HERE */}
      <MightyDataGrid
        entityName="coaches"
        columns={columns}
        rows={rows}
        onRowClick={onCoachClicked}
        rowVirtualization={true}
        columnVirtualization={true}
        viewportOffset={300} // Adjust based on your header height
      />
    </Box>
  );
};

export default CoachTable;
